import  React, { useEffect, useState } from "react";
import { Button } from "./buttons";
import { Checkbox, Dropdown } from "./input";
import "../../styles/forms.css";

export function SubmitButtonGroup({ onSubmit, inProgress = false, autoDisable = true }) {
    const [ canSubmit, setCanSubmit ] = useState(false);
    
    const remarksRef = React.createRef();

    const onClick = () => {
        onSubmit({ remarks: remarksRef.current.value });
        if(autoDisable) setCanSubmit(false);
    };

    return <div className="submission-btngroup">
        <Checkbox defaultValue={canSubmit} onChange={(checked) => setCanSubmit(checked)} /> All data was reviewed and ready to be submitted. <br />   
        { canSubmit ? <input className="input remarks-field" placeholder="Write your remarks" ref={remarksRef} /> : "" }
        <Button disabled={!canSubmit} onClick={onClick} inProgress={inProgress}>SUBMIT</Button>
    </div>;
}

export function ProvinceSelector({ province, collection, onChange }) {
    const [ currentProvince, setCurrentProvince ] = useState(province || "1");
    const provinces = Object.values(collection.province);
    const provinceOptions = [ ...provinces.map(p => ({ label: p.name, value: p.id })) ];

    useEffect(() => {
        onChange(currentProvince);
    });
    
    return <Dropdown key="1" options={provinceOptions} onSelect={(id) => setCurrentProvince(id)} defaultValue={currentProvince} />;
}

export function LocationSelector({ values, collection, provinceFixed = false, lguFixed = false, onChange, includeAll = false }) {

    if(values.lgu && !values.province) {
        const lguData = collection.lgu[values.lgu];
        if(lguData) {
            values.province = collection.province[lguData.province].id;
        }
    } else if(!values.province) {
        values.province = Object.keys(collection.province)[0];
    }

    const [ currentProvince, setCurrentProvince ] = useState(values.province);
    const [ currentLGU, setCurrentLGU ] = useState(values.lgu);

    const provinces = Object.values(collection.province);
    const lgus = Object.values(collection.lgu).filter(lgu => lgu.province === currentProvince);

    const update = (values) => {
        if("lgu" in values) {
            if(values.lgu) setCurrentLGU(values.lgu);
            else if(!includeAll && values.province) {
                setCurrentLGU(Object.values(collection.lgu).find(lgu => lgu.province===values.province)?.id)
            }
        }

        if("province" in values) setCurrentProvince(values.province);   
    };


    onChange({ lgu: currentLGU, province: currentProvince });     

    let provinceOptions = [ ...provinces.map(p => ({ label: p.name, value: p.id })) ];
    let lguOptions = [ ...lgus.map(l => ({ label: l.name, value: l.id })) ];
    
    if(provinceFixed || lguFixed) provinceOptions = provinceOptions.filter(p => p.value === currentProvince);
    if(lguFixed) lguOptions = lguOptions.filter(l => l.value === currentLGU);

    if(includeAll) {
        provinceOptions.unshift({ label: "All Provinces" });
        lguOptions.unshift({ label: "All LGU" });
    }

    return <div style={{ display: "inline-block" }}>
        <Dropdown key={Math.random()} disabled={currentProvince ? false : true} options={lguOptions}
            onSelect={(id) => update({ lgu: id })} defaultValue={currentLGU} />
        <Dropdown key="1" options={provinceOptions}
                onSelect={(id) => update({ lgu: undefined, province: id })} defaultValue={currentProvince} />
    </div>;
}